$(function() {


    const body = $("body");
    const firstStep = $('#first-step');
    const secondStep = $('#second-step');
    const thirdStep = $('#third-step');
    const generalInfoForm = $('#general-info-form');

    body.bind('mouseup touchend', function (e) {
        var container = $('#facing-select');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.options').addClass('options--fade-out');
            $('#facing-select .select').removeClass('hover');
        }
    });
    body.on('click','#facing-select',function(){
        $('.options').toggleClass('options--fade-out');
    })
    body.on('click','.options li',function(e){
        if(!$(this).hasClass("disabled")){
            let content = $(this).html();
            $(".select .label").html(content);
            let selected = null
            $("#facing-select option").map((index,option) => {
                const optionValue = $(option).val();
                if(optionValue.toString().trim() === content.toString().trim()){
                    selected = $(option);
                }
            } );
            if(selected){
                $('#facing-select option:selected').removeAttr('selected');
                selected.attr("selected","selected");
            }
        }else{
            e.stopPropagation();
        }
    });
    let formStatus = 0;
    body.on("submit","#general-info-form",function(e){
        e.preventDefault();
        const errorClass = "error";
        let hasError = 0;
        /* Check first step input */
        if(formStatus === 0){
            firstStep.find("input").each((index,input) =>{
                const $input = $(input);
                if($input.val() === ""){
                    $input.addClass(errorClass);
                    hasError++;
                }else{
                    $input.removeClass(errorClass)
                }
            });
            if(hasError === 0){
                formStatus++;
                firstStep.addClass("transform");
                secondStep.removeClass("d-none");
                setTimeout(() => {
                    firstStep.addClass("d-none");
                    secondStep.addClass("transform")
                },0);

                generalInfoForm.addClass("h-600");
                $( "li.md-progress-bar-li:nth-child(2)" ).addClass("md-progress-bar-li-active")
            }
        }else if(formStatus === 1){
            /* Check second step input */
            secondStep.find("input").each((index,input) =>{
                const $input = $(input);
                if($input.val() === ""){
                    $input.addClass(errorClass);
                    hasError++;
                }else{
                    $input.removeClass(errorClass)
                }
            });
            /* Check select usage*/
            const selectedOption = $("#facing-select-select option:selected").val();
            if(selectedOption === ""){
                $("#facing-select-select").addClass(errorClass);
                hasError++;
            }else{
                $("#facing-select-select").removeClass(errorClass);
            }
            if(hasError === 0){
                formStatus++;
                secondStep.removeClass("transform");
                thirdStep.removeClass("d-none");
                setTimeout(() => {
                    secondStep.addClass("d-none");
                    thirdStep.addClass("transform");
                },0);
                generalInfoForm.removeClass("h-600");
                $( "li.md-progress-bar-li:nth-child(3)" ).addClass("md-progress-bar-li-active")
            }
        }else if(formStatus === 2){
            /* Textarea */
            const textarea = $( "textarea[name='note']" );
            if(textarea.val() === ""){
                textarea.addClass(errorClass);
                hasError++;
            }else{
                textarea.removeClass(errorClass);
                /* Check third step input */
                e.currentTarget.submit();
            }


        }
    });
    /* Checkbox management on second step */
    body.on('click','.advertise-card-5',function(){
        const pipeContainer = $(this).find("div.advertise-card-5-pipe");
        const img = $(this).find("img.advertise-card-5-pipe-img");
        const checkbox = $(this).find('input.advertise-card-5-checkbox');
        checkbox.prop("checked", !checkbox.prop("checked"));
        const currentImg = img.attr("src");
        const changeImg = img.data("changesrc");
        pipeContainer.toggleClass("green-bg");
        img.attr("src",changeImg);
        img.data("changesrc",currentImg);
    });
    /* Prev arrow click events handling second step*/
    body.on('click','#second-prev',function(){
        formStatus--;
        firstStep.removeClass("d-none");
        secondStep.removeClass("transform");
        setTimeout(() => {
            firstStep.removeClass("transform ");
            secondStep.addClass("d-none");
        },0);
        generalInfoForm.removeClass("h-600");
        $( "li.md-progress-bar-li:nth-child(2)" ).removeClass("md-progress-bar-li-active")
    });
    /* Prev arrow click event handling on third step*/
    body.on('click','#third-prev',function(){
        formStatus--;
        thirdStep.removeClass("transform");
        secondStep.removeClass("d-none");
        setTimeout(() => {
            thirdStep.addClass("d-none")
            secondStep.addClass("transform")
        },0);
        generalInfoForm.addClass("h-600");
        $( "li.md-progress-bar-li:nth-child(3)" ).removeClass("md-progress-bar-li-active")
    })
});

